// configuration app insights
// tracking front-end navigation
// the admin can see the application map on Azure Dashboard

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";

const isTrackingEnabled = !!process.env.REACT_APP_INSIGHTS_ENABLED;
const InsightsReactPlugin = new ReactPlugin();

if (isTrackingEnabled) {
    const browserHistory = createBrowserHistory({ basename: "" } as Parameters<typeof createBrowserHistory>[0]);

    //Replace the value of the "zoho_key" parameter with "PII"
    const urlWithUpdatedParam = updateURLParameter((window.location as Location).search, "zoho_key", "PII");
    //Update the browser history with the modified URL
    const updatedBrowserHistory = {
        ...browserHistory,
        location: {
            ...browserHistory.location,
            search: urlWithUpdatedParam
        }
    };

    const appInsightsConnectionString = process.env.REACT_APP_INSIGHTS_CONNECTION_STRING;
    const appInsights = new ApplicationInsights({
        config: {
            connectionString: appInsightsConnectionString,
            extensions: [InsightsReactPlugin],
            extensionConfig: {
                [InsightsReactPlugin.identifier]: { history: updatedBrowserHistory },
            },
            autoTrackPageVisitTime: true
        },
    });

    appInsights.setAuthenticatedUserContext("GpMediation");
    appInsights.loadAppInsights();
}

// Function to update the value of a specific parameter in the URL
function updateURLParameter(url: string, parameter: string, value: string) {
    const urlParts = url.split('?');
    if (urlParts.length >= 2) {
        const prefix = encodeURIComponent(parameter) + '=';
        const parts = urlParts[1].split(/[&;]/g);

        // Loop through the parts and update the parameter value if found
        for (let i = 0; i < parts.length; i++) {
            if (parts[i].lastIndexOf(prefix, 0) !== -1) {
                parts[i] = prefix + encodeURIComponent(value);
                break;
            }
        }

        // Update the URL with the modified parameters
        url = urlParts[0] + '?' + parts.join('&');
    }
    return url;
}

export default InsightsReactPlugin;